import { Box } from '@monorepo/nova-ui';
import { styled } from '@mui/material/styles';

export const StyledMenuMobileWrapper = styled(Box)(({ theme }) => ({
  marginRight: theme.spacing(6),
  display: 'none',
  '@media (max-width: 1366px)': {
    display: 'block',
  },
}));
